import _ from 'underscore'
import React from 'react'
import LeadLabelsPartial from './partial'

class LeadLabels extends React.Component {

  render() {
    return (
      <section className="inline-flex flex-wrap gap-1.5">
        {_.map(this.props.labels, function(label) {
          return <LeadLabelsPartial key={label.id} label={label}/>
        })}
      </section>
    )
  }
}

export default LeadLabels
